"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const change_tab_1 = require("./change-tab");
function actions({ onTabChange, }) {
    return {
        changeTab: change_tab_1.changeTab({ onTabChange }),
    };
}
exports.actions = actions;
//# sourceMappingURL=actions.js.map